import React, { useState, useEffect } from "react";
import { Modal, Form, Input, message, notification } from "antd";
import DovizSelectOption from "../toolbox/DovizSelectOption";
import strings from "../../utils/Localization";
import { useDispatch } from "react-redux";
import { setRerender } from "../../redux/actions/rerenderAction";
import useApi from "../../hooks/useApi";

const formSize = "middle";

function KasaDuzenleModal({ visible = false, handleCancel, data = null }) {
  const [fetchLoading, setFetchLoading] = useState(false);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const api = useApi();
  const { kasaDuzenleModal: localization } = strings.kasa;

  useEffect(() => {
    if (data !== null) {
      form.setFieldsValue({
        id: data.id,
        kasaAdi: data.ad,
        dovizId: String(data.doviz.id),
      });
    }
  }, [data]); // eslint-disable-line react-hooks/exhaustive-deps

  const onFinish = async (values) => {
    try {
      setFetchLoading(true);
      const { kasaAdi, dovizId, id } = values;

      const response = await api.put("/kasa", {
        Id: id,
        Ad: kasaAdi,
        DovizId: dovizId,
      });

      if (response.status === 200) {
        notification["success"]({
          message: strings.mesaj.basarliBaslik,
          description: strings.mesaj.islemBasarili,
        });
        dispatch(setRerender());
      }
    } catch (error) {
      message.error(error.message);
    } finally {
      setFetchLoading(false);
    }
  };

  return (
    <Modal
      title={localization.baslik}
      visible={visible}
      onCancel={handleCancel}
      handleCancel={handleCancel}
      okButtonProps={{
        htmlType: "submit",
        form: "kasaDuzenleModal",
        size: formSize,
        loading: fetchLoading,
      }}
      cancelButtonProps={{ size: formSize }}
    >
      <Form
        name="kasaDuzenleModal"
        form={form}
        onFinish={onFinish}
        layout="vertical"
        size={formSize}
      >
        <Form.Item noStyle hidden name="id" />
        <Form.Item
          name="kasaAdi"
          label={localization.kasaAdi}
          rules={[{ required: true }]}
        >
          <Input placeholder={localization.kasaAdiPlaceHolder} />
        </Form.Item>
        <Form.Item
          name="dovizId"
          label={strings.dovizSelectOption.dovizBaslik}
          rules={[{ required: true }]}
        >
          <DovizSelectOption disabled />
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default KasaDuzenleModal;
